export enum AttachmentPolicyInfoBarId {
    InfoRestrictedAccess = 'infoRestrictedAccess',
}
